// Copy for the sections ported from v2, as { pt, en } pairs (resolved by lib/useLang).

export const LINKS = {
  email: 'duduscala@gmail.com',
  github: 'https://github.com/Dudu-Brancalhao/',
  linkedin: 'https://www.linkedin.com/in/eduardo-brancalhao/',
  resume: { pt: '/dudu_curriculo.pdf', en: '/dudu_resume.pdf' },
}

export const UI = {
  nav: {
    home: { pt: 'Início', en: 'Home' },
    work: { pt: 'Projetos', en: 'Work' },
    stack: { pt: 'Stack', en: 'Stack' },
    about: { pt: 'Sobre', en: 'About' },
    contact: { pt: 'Contato', en: 'Contact' },
  },
  resume: { pt: 'Currículo', en: 'Resume' },
  menu: { pt: 'Menu', en: 'Menu' },
  close: { pt: 'Fechar', en: 'Close' },
  loading: { pt: 'Carregando experiência', en: 'Loading experience' },
  hello: { pt: 'Olá, eu sou', en: 'Hello, I am' },
  role: { pt: 'Engenheiro de Software', en: 'Software Engineer' },
  heroLine: {
    pt: 'Construo sistemas que movimentam dinheiro real — e interfaces que as pessoas gostam de usar.',
    en: 'I build systems that move real money — and interfaces people actually enjoy using.',
  },
  available: { pt: 'Disponível para novos projetos', en: 'Available for new projects' },
  scroll: { pt: 'Role para explorar', en: 'Scroll to explore' },
  talk: { pt: 'Vamos conversar', en: "Let's talk" },
  seeWork: { pt: 'Ver projetos', en: 'See my work' },
  based: { pt: 'Baseado no Brasil', en: 'Based in Brazil' },
  workTitle: { pt: 'Trabalhos selecionados', en: 'Selected work' },
  workSub: { pt: 'Conheça meu trabalho', en: 'Know my work' },
  view: { pt: 'Ver', en: 'View' },
  drag: { pt: 'Arraste', en: 'Drag' },
  yourProject: { pt: 'Aqui pode ser seu projeto!', en: 'This could be your project!' },
  overview: { pt: 'Visão geral', en: 'Overview' },
  features: { pt: 'Principais funcionalidades', en: 'Key features' },
  myRole: { pt: 'Meu papel', en: 'My role' },
  stackTools: { pt: 'Stack & ferramentas', en: 'Stack & tools' },
  gallery: { pt: 'Galeria', en: 'Gallery' },
  nextProject: { pt: 'Próximo projeto', en: 'Next project' },
  stackTitle: { pt: 'Ferramentas', en: 'Toolbox' },
  stackSub: { pt: 'É aqui que a mágica é feita', en: 'This is where the magic is made' },
  stackHint: { pt: 'Arraste a esfera', en: 'Drag the sphere' },
  aboutTitle: { pt: 'Sobre mim', en: 'About me' },
  highlights: { pt: 'Principais destaques', en: 'Main highlights' },
  years: { pt: 'anos entregando software', en: 'years shipping software' },
  projectsCount: { pt: 'projetos em destaque', en: 'featured projects' },
  toolsCount: { pt: 'ferramentas no dia a dia', en: 'tools in daily use' },
  contactTitle: { pt: 'Tem uma ideia?', en: 'Got an idea?' },
  contactBig: { pt: 'Vamos construir algo incrível.', en: "Let's build something remarkable." },
  copyEmail: { pt: 'Copiar e-mail', en: 'Copy email' },
  copied: { pt: 'Copiado!', en: 'Copied!' },
  madeBy: { pt: 'Desenvolvido por', en: 'Designed & built by' },
  backTop: { pt: 'Voltar ao topo', en: 'Back to top' },
  localTime: { pt: 'Horário local', en: 'Local time' },
}

// Rich text: segments wrapped in *asterisks* are highlighted.
export const MANIFESTO = {
  pt: 'Sou engenheiro de software com *4+ anos* entregando software em produção. Comecei no frontend, evoluí para o fullstack com visão de produto e hoje atuo como *engenheiro backend* em *FinTech e crypto wallets*, construindo os sistemas que movimentam dinheiro e ativos reais *on-chain*.',
  en: 'I am a software engineer with *4+ years* shipping production software. I started in frontend, grew into product-minded fullstack, and today I work as a *backend engineer* in *FinTech and crypto wallets*, building the systems that move real money and assets *on-chain*.',
}

export const ABOUT = [
  {
    pt: 'Meu nome é *Eduardo Brancalhão* e sou *engenheiro de software*, com mais de 4 anos de experiência no mercado. Sou graduado em Engenharia de Software (UNICESUMAR) e já atuava na área antes mesmo de me formar.',
    en: 'My name is *Eduardo Brancalhão* and I am a *software engineer* with 4+ years of experience. I hold a Software Engineering degree (UNICESUMAR) and have been working in the field since before graduating.',
  },
  {
    pt: 'Hoje atuo como *engenheiro backend* em *FinTech e crypto wallets*, construindo infraestrutura blockchain e a lógica de backend por trás de *prediction markets*, com *Node.js*, *Prisma ORM* e *PostgreSQL*. Como boa parte do meu trabalho vive onde finanças encontram confiabilidade, me preocupo profundamente com *segurança e integridade de dados*.',
    en: 'Today I work as a *backend engineer* in *FinTech and crypto wallets*, building blockchain infrastructure and the backend logic behind *prediction markets*, with *Node.js*, *Prisma ORM* and *PostgreSQL*. Since much of my work lives where finance meets reliability, I care deeply about *security and data integrity*.',
  },
  {
    pt: 'Desenvolvo com uma abordagem *AI-native e Spec-Driven*: primeiro defino regras, arquitetura e restrições, depois executo com *workflows multi-agente* (Claude Code, agent loops, git worktrees). Também gerencio deploys em *VPS Linux*, proxies e pipelines de *CI/CD (GitHub Actions)*.',
    en: 'I build with an *AI-native, Spec-Driven* approach: rules, architecture and constraints first, then execution with *multi-agent workflows* (Claude Code, agent loops, git worktrees). I also manage *Linux VPS* deployments, proxies and *CI/CD pipelines (GitHub Actions)*.',
  },
]

export const HIGHLIGHTS = [
  {
    icon: 'wallet',
    title: { pt: 'Crypto wallets & infraestrutura blockchain', en: 'Crypto wallets & blockchain infrastructure' },
    body: {
      pt: 'Sistemas de backend para carteiras de criptomoedas e infraestrutura on-chain, para produtos próprios e como serviço para outras empresas de crypto wallets.',
      en: 'Backend systems for cryptocurrency wallets and on-chain infrastructure, both for in-house products and as development services for other crypto-wallet companies.',
    },
  },
  {
    icon: 'chart',
    title: { pt: 'Prediction markets & integrações', en: 'Prediction markets & integrations' },
    body: {
      pt: 'Lógica de backend por trás de prediction markets, incluindo integração com a Polymarket (CLOB, settlement on-chain, import e auto-resolução de mercados).',
      en: 'Backend logic behind prediction markets, including Polymarket integration (CLOB order-book, on-chain settlement, market import and auto-resolution).',
    },
  },
  {
    icon: 'shield',
    title: { pt: 'Segurança & integridade de dados', en: 'Security & data integrity' },
    body: {
      pt: 'Revisões de segurança, correção de vulnerabilidades de autenticação/autorização e remediação de integridade de dados em sistemas financeiros em produção.',
      en: 'Security reviews, fixing authentication/authorization vulnerabilities and remediating data-integrity issues in live financial systems.',
    },
  },
  {
    icon: 'spark',
    title: { pt: 'Desenvolvimento AI-native', en: 'AI-native development' },
    body: {
      pt: 'Regras, arquitetura e restrições primeiro; depois execução com workflows multi-agente para acelerar a entrega e a qualidade do design de sistemas.',
      en: 'Rules, architecture and constraints first, then multi-agent coding workflows to accelerate delivery and system-design quality.',
    },
  },
]

export const MARQUEE = ['Backend', 'FinTech', 'On-chain', 'Fullstack', 'UI/UX', 'Design Systems', 'Security', 'AI-native', 'CI/CD']

export const STACK = [
  'figma', 'vscode', 'javascript', 'typescript', 'html', 'css', 'react', 'tailwind', 'next',
  'postgres', 'prisma', 'github', 'java', 'springBoot', 'node', 'claude', 'supabase', 'graphql',
]
